import "bootstrap/js/dist/util";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";
import "jquery-match-height";
import Vue from "vue";
import SmoothScroll from "smooth-scroll";
import ApplicationForm from "./components/application-form";
import "./cf7";
import "slick-carousel";

const initScroll = () => {
  const url = window.location.href;

  if (url.split("#").length !== 2) {
    return;
  }

  const destination = url.split("#")[1];

  if (!destination) {
    return;
  }

  const target = document.querySelector(destination);

  if (target) {
    new SmoothScroll().animateScroll(target);
  }
};

class App {
  static init() {
    initScroll();

    if (document.getElementById("app")) {
      new Vue({ components: { ApplicationForm } }).$mount("#app");
    }

    $("section.form-result-november .logos-slider .slick-slider").slick({
      variableWidth: true,
      arrows: false,
      dots: false,
      autoplay: true
    });

    $("section.home-form .slick-slider").slick({
      arrows: false,
      dots: false,
      autoplay: true,
      slidesToShow: 7,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            variableWidth: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            variableWidth: true,
            slidesToShow: 2
          }
        }
      ]
    });

    $(document.body).on("click", "a[href*='#']", e => {
      const item = e.currentTarget;

      if (item.href.split("#").length !== 2) {
        return true;
      }

      const destination = item.href.split("#")[1];

      const splitter = /[#?]/;

      if (
        item.href.split(splitter)[0] !== window.location.href.split(splitter)[0]
      ) {
        return true;
      }

      const target = document.querySelector(destination);

      e.preventDefault();

      new SmoothScroll().animateScroll(target);

      return false;
    });

    $('.brochure-button[href="#"]').on("click", e => {
      e.preventDefault();
      $(".brochure-button").fadeOut(500, () => {
        $(".brochure-button")
          .next()
          .fadeIn();
      });
    });
  }
}

App.init();
